export function getStandardDomesticPricing(domesticeServiceBins, wasteBinAddNew, recycleBinAddNew, organicBinAddNew, priceData) {
    const standardOrderDetails = {
      totalInitialFees: 0,
      totalAnnualFees: 0,
      items: []
    };  
  
    const newServicePricing = priceData[0];
    const wasteBinPricing = priceData[1];
    const recyclingBinPricing = priceData[2];
    const organicBinPricing = priceData[3];
  
    const newServicePrice = newServicePricing.initalFee * domesticeServiceBins;
    const wastePrice = wasteBinPricing.initalFee * wasteBinAddNew;
    const recyclePrice = recyclingBinPricing.initalFee * recycleBinAddNew;
    const organicPrice = organicBinPricing.initalFee * organicBinAddNew;
    
    const newServiceAnnualPrice = newServicePricing.annualFee * domesticeServiceBins;
    const wasteAnnualPrice = wasteBinPricing.annualFee * wasteBinAddNew;
    const recycleAnnualPrice = recyclingBinPricing.annualFee * recycleBinAddNew;
    const organicAnnualPrice = organicBinPricing.annualFee * organicBinAddNew;

    if (domesticeServiceBins > 0) {
      standardOrderDetails.items.push({
            description: 'Domestic Waste Service',
            quantity: domesticeServiceBins,
            upfront: newServicePrice,
            annual: newServiceAnnualPrice
        });
    }

    if (wasteBinAddNew > 0) {
      standardOrderDetails.items.push({
            description: 'Additional Waste(Red) Bin',
            quantity: wasteBinAddNew,
            upfront: wastePrice,
            annual: wasteAnnualPrice
        });
    }

    if (recycleBinAddNew > 0) {
      standardOrderDetails.items.push({
            description: 'Additional Recycle(Yellow) Bin',
            quantity: recycleBinAddNew,
            upfront: recyclePrice,
            annual: recycleAnnualPrice
        });
    }

    if (organicBinAddNew > 0) {
      standardOrderDetails.items.push({
            description: 'Additional Organic(Green) Bin',
            quantity: organicBinAddNew,
            upfront: organicPrice,
            annual: organicAnnualPrice
        });
    }

    standardOrderDetails.totalInitialFees = newServicePrice + wastePrice + recyclePrice + organicPrice;
    standardOrderDetails.totalAnnualFees = newServiceAnnualPrice + wasteAnnualPrice + recycleAnnualPrice + organicAnnualPrice;

    return standardOrderDetails;
}

export function getAddtionalBinPricing(wasteBinAdd, recycleBinAdd, organicBinAdd, priceData) {
    const additionalBinOrderDetails = {
      totalInitialFees: 0,
      totalAnnualFees: 0,
      items: []
    };

    const wasteBinPricing = priceData[1];
    const recyclingBinPricing = priceData[2];
    const organicBinPricing = priceData[3];

    const wastePrice = wasteBinPricing.initalFee * wasteBinAdd;
    const recyclePrice = recyclingBinPricing.initalFee * recycleBinAdd;
    const organicPrice = organicBinPricing.initalFee * organicBinAdd;

    const wasteAnnualPrice = wasteBinPricing.annualFee * wasteBinAdd;
    const recycleAnnualPrice = recyclingBinPricing.annualFee * recycleBinAdd;
    const organicAnnualPrice = organicBinPricing.annualFee * organicBinAdd;

    if (wasteBinAdd > 0) {
      additionalBinOrderDetails.items.push({
            description: 'Additional Waste(Red) Bin',
            quantity: wasteBinAdd,
            upfront: wastePrice,
            annual: wasteAnnualPrice
        });
    }

    if (recycleBinAdd > 0) {
      additionalBinOrderDetails.items.push({
            description: 'Additional Recycle(Yellow) Bin',
            quantity: recycleBinAdd,
            upfront: recyclePrice,
            annual: recycleAnnualPrice
        });
    }

    if (organicBinAdd > 0) {
      additionalBinOrderDetails.items.push({
            description: 'Additional Organic(Green) Bin',
            quantity: organicBinAdd,
            upfront: organicPrice,
            annual: organicAnnualPrice
        });
    }

    additionalBinOrderDetails.totalInitialFees = wastePrice + recyclePrice + organicPrice;
    additionalBinOrderDetails.totalAnnualFees = wasteAnnualPrice + recycleAnnualPrice + organicAnnualPrice;

    return additionalBinOrderDetails;
}

export function getRecyclingSizePricing(changeRecycleBin, priceData) {
    const recyclingResizeOrderDetails = {
      totalInitialFees: 0,
      totalAnnualFees: 0,
      items: []
    };

    const recyclingBinPricing = priceData[2];

    recyclingResizeOrderDetails.totalInitialFees = recyclingBinPricing.initalFee * changeRecycleBin;

    if (changeRecycleBin > 0) {
      recyclingResizeOrderDetails.items.push({
            description: 'Resize Recycle(Yellow) Bin',
            quantity: changeRecycleBin,
            upfront: recyclingResizeOrderDetails.totalInitialFees,
            annual: 0
        });
    }

    return recyclingResizeOrderDetails;
}